import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabaseClient'
import useStore from './hooks/useStore'
import Auth from './pages/Auth'
import Dashboard from './pages/Dashboard'
import LandingPage from './pages/LandingPage'
import './App.css'

function App() {
  const { user, setUser, isLoading } = useStore()
  const isRecoveryFlow = typeof window !== 'undefined' && window.location.pathname === '/auth' && window.location.hash.includes('type=recovery')

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession()
        if (error) console.error('Session error:', error)
        setUser(session?.user ?? null)
      } catch (error) {
        console.error('Auth initialization error:', error)
        setUser(null)
      }
    }

    initializeAuth()

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => { setUser(session?.user ?? null) }
    )

    return () => subscription.unsubscribe()
  }, [setUser])

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'var(--bg)',
        color: 'var(--text)',
        fontFamily: "'Syne', sans-serif",
        fontSize: '13px',
        letterSpacing: '0.15em',
        textTransform: 'uppercase',
        opacity: 0.5
      }}>
        Loading…
      </div>
    )
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={user ? <Navigate to="/morning" replace /> : <LandingPage />}
          />
          <Route
            path="/auth"
            element={user && !isRecoveryFlow ? <Navigate to="/morning" replace /> : <Auth />}
          />
          <Route
            path="/*"
            element={user ? <Dashboard /> : <Navigate to="/" replace />}
          />
        </Routes>
      </div>
    </Router>
  )
}

export default App
